import i18n from 'i18next';
import countriesData from '../assets/countries.json';

const BACKEND_URL = 'https://appstral-backend-798861160394.us-central1.run.app';

export const searchCities = async (country, query) => {
  if (!country) return [];
  const lang = (i18n.language || 'es').slice(0, 2) === 'en' ? 'en' : 'es';
  const params = new URLSearchParams({ country, lang });
  if (query) params.set('q', query);
  const response = await fetch(`${BACKEND_URL}/api/cities/search?${params.toString()}`);
  if (!response.ok) throw new Error('Error al buscar ciudades');
  return response.json();
};

/**
 * Igual que `searchCities` pero sin filtrar por país: trae las coincidencias de
 * todos los países a la vez (el backend omite el filtro cuando no le llega
 * `country`). Es la que usa el buscador de ciudad de un solo campo.
 */
export const searchCitiesGlobal = async (query) => {
  if (!query) return [];
  const lang = (i18n.language || 'es').slice(0, 2) === 'en' ? 'en' : 'es';
  const params = new URLSearchParams({ q: query, lang });
  const response = await fetch(`${BACKEND_URL}/api/cities/search?${params.toString()}`);
  if (!response.ok) throw new Error('Error al buscar ciudades');
  return response.json();
};

/**
 * "Ciudad, País" para las filas del dropdown de búsqueda global: sin el país
 * al lado no hay forma de distinguir los homónimos (Santiago, San Miguel).
 */
export const formatCityCountry = (item, lang) => {
  const countryName = countriesData[item.country]?.[lang] || item.country;
  return `${item.label}, ${countryName}`;
};

/**
 * Recorta el sufijo de desambiguación "(Provincia)" que traen algunas ciudades
 * del backend. Solo para pantallas de detalle/resultado, nunca en el dropdown
 * de búsqueda: ahí el sufijo es justamente lo que permite elegir bien.
 */
export const displayCityName = (cityLabel) => {
  if (!cityLabel) return cityLabel;
  return cityLabel.replace(/\s*\([^)]*\)\s*$/, '').trim();
};
